export class IAuth {
    constructor() {
    }

    async registerWithEmailAndPassword() {
    }

    async loginWithEmailAndPassword() {
    }

    async verifyLogin() {
    }
}